export class Conclusions {
    static moduleName = 'conclusions';
    static entityName = 'conclusion';
    static listTitle = 'Справочник заключений';
    static createTitle = 'Добавление нового заключения';
    static apiPrefix = '/conclusions';
}